module.exports = __webpack_public_path__ + "static/media/phrase-welcome.a7c0e088.svg";